import { DatabaseZap } from 'lucide-react';
import { type FC } from 'react';

import { cn } from '@/lib/utils';

interface InterfaceStatusTriggerContentProps {
  dotColor?: string | null;
}

const InterfaceStatusTriggerContent: FC<InterfaceStatusTriggerContentProps> = ({ dotColor }) => (
  <>
    <DatabaseZap className="size-5" />
    {dotColor && <span aria-hidden className={cn('size-3 shrink-0 rounded-full', dotColor)} />}
  </>
);

export default InterfaceStatusTriggerContent;
